import { PstNews } from '@pst/biz';
import { createSingletonPromise, retryService } from '@pst/utils';
import { projectConfig } from '../config';

export const newsModule = new PstNews({
  language: 'zh-CN',
  region: projectConfig.region,
});

const website = window.entryType === 'pc' ? newsModule.WebsiteType.PC : newsModule.WebsiteType.Mobile;

newsModule.getAllNews({
  channel: newsModule.NewsType.News,
  website,
});

newsModule.getAllNews({
  channel: newsModule.NewsType.Updates,
  website,
});

// https://game.bytedance.net/gms/677975/site-content/ad/edit?id=7535041957286992649
export interface DownloadConfig {
  pcLauncherText: string;
  pcLauncherQALink: string;
  pcLauncherCommunityLink: string;
}

let cache: DownloadConfig | undefined;

const _getDownloadConfig = retryService(
  async (): Promise<DownloadConfig | undefined> => {
    if (cache) {
      return cache;
    }
    // return {
    //   pcLauncherQALink: 'https://wylr.nvsgames.cn/',
    //   pcLauncherCommunityLink: 'https://wylr.nvsgames.cn/?1',
    // };
    const res = await newsModule.instance.getPicture({
      // 这里只配置在 PC
      website: newsModule.websiteTypes[projectConfig.appId].PC,
      block: 1,
      channel: 3,
      page: 2,
    });
    const data = res?.[0]?.description || '{}';
    const config = JSON.parse(data);
    cache = config;
    console.log(config);
    return config;
  },
  {
    sleepTime: 100,
  },
);

export const getDownloadConfig = createSingletonPromise(async (): Promise<DownloadConfig | undefined> => {
  try {
    const res = await _getDownloadConfig();
    return res;
  } catch (err) {
    console.error(err);
    return undefined;
  }
});

getDownloadConfig();
